import _Button from "@arco-design/web-react/es/Button";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _Trigger from "@arco-design/web-react/es/Trigger";
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { IconMessage, IconCustomerService, IconClose } from '@arco-design/web-react/icon';
import style from './style.less';
import { isExternal } from '../enableFeature';
var DpFeedback = function DpFeedback() {
  var _a = __read(useState(false), 2),
    isReady = _a[0],
    setIsReady = _a[1];
  var _b = __read(useState(false), 2),
    hide = _b[0],
    setHide = _b[1];
  useEffect(function () {
    var dom;
    var id = 'arco-dp-survey';
    if (!document.getElementById(id)) {
      var scriptJs = document.createElement('script');
      scriptJs.src = 'https://lf1-cdn-tos.bytescm.com/obj/static/dp/bridge/public/feedback/5.6.19/tob/default/dp.feedback.js';
      scriptJs.onload = function () {
        var dpFeedback = window.dpFeedback;
        if (typeof dpFeedback === 'function') {
          dpFeedback({
            showButton: false,
            buttonType: 'dial',
            text: '问题反馈',
            username: window.__user__ && window.__user__.username,
            token: 'c22ce6b46fcc07a9501b9d7dfdb8ad55'
          });
        }
        setIsReady(true);
      };
      dom = document.createElement('div');
      dom.id = id;
      dom.appendChild(scriptJs);
      document.body.appendChild(dom);
    }
    return function () {
      dom && document.body.removeChild(dom);
    };
  }, []);
  return isReady && !hide ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(_Trigger, {
    popupAlign: {
      top: 0
    },
    popup: function popup() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 12
        }
      }, /*#__PURE__*/React.createElement(_Tooltip, {
        content: "\u79BB\u5F00\u5F53\u524D\u9875\u9762\u524D\u4E0D\u518D\u5C55\u793A\u53CD\u9988\u5165\u53E3",
        position: "left"
      }, /*#__PURE__*/React.createElement(_Button, {
        "data-log-click": "{ \"event\": \"feedback_hide\" }",
        className: style['menu-button'],
        shape: "circle",
        icon: /*#__PURE__*/React.createElement(IconClose, null),
        onClick: function onClick() {
          setHide(true);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 12
        }
      }, /*#__PURE__*/React.createElement(_Tooltip, {
        content: "\u7ACB\u5373\u53CD\u9988",
        position: "left"
      }, /*#__PURE__*/React.createElement(_Button, {
        "data-log-click": "{ \"event\": \"feedback_click\" }",
        className: style['menu-button'],
        onClick: function onClick() {
          var _a;
          (_a = window.dpFeedback) === null || _a === void 0 ? void 0 : _a.openFeedback();
        },
        shape: "circle",
        icon: /*#__PURE__*/React.createElement(IconCustomerService, null)
      }))));
    },
    trigger: ['click', 'hover'],
    clickToClose: false,
    position: "top"
  }, /*#__PURE__*/React.createElement(_Button, {
    className: style['trigger-button'],
    icon: /*#__PURE__*/React.createElement(IconMessage, null),
    type: "primary",
    shape: "circle"
  })), document.body) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default (function () {
  return isExternal ? /*#__PURE__*/React.createElement(DpFeedback, null) : null;
});